import ApiSeervice from '../apiservice'

export default class HistoricoProcessoService extends ApiSeervice {

  constructor() {
    super('/historicoProcesso')
  }

  incluirHistorico(historico) {
    return this.post('/',historico);
  }

  listarHistorico(processo,classificacao,ordencacao) {
    return this.get(`/${processo}/${classificacao}/${ordencacao}`);
  }

  excluirHistorico(codigo) {
    return this.delete(`/${codigo}`);
  }
}